export default class PaymentLink{

    constructor(json) {
        this.paymentMethodName = json['paymentMethodName'];
        this.paymentUrl = json['paymentUrl'];
    }
}